import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SignupCheckService } from '@app/shared-signup/signup-check.service';
import { clickableElement, IClickableElement } from '@app/shared/clickable-element';
import { translate } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { IInvitation } from '@app/models/signup';

@Component({
  selector: 'app-invitation-b2b-client-account-list',
  templateUrl: './invitation-b2b-client-account-list.component.html',
  styleUrls: ['./invitation-b2b-client-account-list.component.scss']
})
export class InvitationB2bClientAccountListComponent implements OnInit {

  get changeAccountOrCreateOrgaText(): SafeHtml {
    const text = translate('Si cette invitation concerne une autre organisation, vous pouvez $changeAccount$ ou $createNewOrganisation$.',
      {
        changeAccount: this.clickChangeAccountElement.html,
        createNewOrganisation: this.clickCreateNewOrganisationElement.html
      });
    return this.domSanitizer.bypassSecurityTrustHtml(text);
  }
  @Input() accounts = [];
  @Input() selectedAccount = null;
  @Input() links = null;
  @Input() invitation : IInvitation;
  @Output() selectAccount = new EventEmitter();


  loading = false;
  hasBackButton = false;
  url: '';
  user: {
    id: number,
    login: string,
    email: string,
    first_name: string,
    last_name: string,
    avatar_url: string
  };
  boolean;
  private clickChangeAccountElement: IClickableElement;
  private clickCreateNewOrganisationElement: IClickableElement;
  constructor(
    private router: Router,
    public checkService: SignupCheckService,
    protected domSanitizer: DomSanitizer,
    private store: Store) {
  }

  ngOnInit() {
    this.user = window['CONST_USER'];
    this.clickChangeAccountElement = clickableElement({
      text: translate('changer de compte'),
      className: 'link blue',
      callback: () => {
        this.changeAccount();
      },
    });
    this.clickCreateNewOrganisationElement = clickableElement({
      text: translate('creer une nouvelle organisation'),
      className: 'link blue',
      callback: () => {
        this.createOrganisation();
      },
    });
  }
  
  select(account) {
    if (this.canSwitchTo(account)) {
      this.selectedAccount = account;
      this.selectAccount.emit(account);
    }
  }

  createOrganisation() {
    this.router.navigate(['/signup/steps'], { state: ['change_account'] });
  }

  changeAccount(): void {
    this.router.navigate(['/change_account']);
  }

  back() {
    this.router.navigate(['/signup']);
  }

  canSwitchTo(account: any) {
    if (account) {
      return (
        account.type === 'owner' &&
        !account.in_partnership_full_access
      );
    }
  }

  getDisabledReason(account): string | false {

    if(account.id === this.invitation.account.id){
      return `${translate('Cette organisation est déjà partenaire.')} ${translate('Veuillez sélectionner une autre organisation.')}`;
    }
    if (account.in_partnership_full_access) {
      return translate('Vous ne pouvez avoir qu\'un seul partenaire sur votre organisation quand celui-ci possede des droits d\'acces complet');
    }

    if (!this.canSwitchTo(account)) {
      return translate('Seuls les responsables legaux de cette organisation peuvent accepter les invitations de partenariat.');
    }

    return false;
  }


}
